import { IQueryImages } from 'src/app/home-page/services/bootstrap-query.service';
import { IPreviewCard } from './IPreviewClass';

export class PreviewCard {
  public imagesUrl: string;
  public title: string;
  public id: number;
  public class: 'category-max' | 'category-min' | 'brand';
  public backgroundImages: IQueryImages;
  public onClick: () => void;

  constructor(private previewCard: IPreviewCard) {
    this.id = previewCard.id;
    this.title = previewCard.title;
    this.class = previewCard.class;
    this.backgroundImages = {
      xxl: this.getImageUrl(previewCard.backgroundImages, 6),
      xl: this.getImageUrl(previewCard.backgroundImages, 5),
      lg: this.getImageUrl(previewCard.backgroundImages, 4),
      md: this.getImageUrl(previewCard.backgroundImages, 3),
      sm:
        this.getImageUrl(previewCard.backgroundImages, 7) ??
        this.getImageUrl(previewCard.backgroundImages, 2),
      xs:
        this.getImageUrl(previewCard.backgroundImages, 2) ??
        this.getImageUrl(previewCard.backgroundImages, 7),
    };
    this.onClick = previewCard?.onClick;
  }

  private getImageUrl(imagesArray, idType): string {
    return imagesArray.find((image) => image.tipo == idType)?.imagen;
  }
}
